import { FreeText } from "assets/icons";
import { PencilForWidget } from "assets/icons/Common";
import { InformationSetting } from "components/settings";
import { WidgetType } from "types/Widget";

import { CanvasScreen } from "./Canvas";
import FreeDrawingToolSettings from "./FreeDrawingSettings";

export const FreeDrawingWidget: WidgetType = {
  name: "Free Drawing",
  component: CanvasScreen, // No type conflict here now
  icon: PencilForWidget,
  showOnToolbar: true,
  sizing: {
    minWidth: 400,
    minHeight: 300,
    minAspectRatio: 0.5,
    maxAspectRatio: 1.75,
  },
  defaultState: {
    canvas: {
      backgroundColor: "#ffffff",
      drawings: [],
      selectedTool: "pencil",
      lineWeight: 2,
      color: "#000000",
      disableDrag: false,
    },
  },
  defaultSize: {
    aspectRatio: 1.5,
    widthPercentage: 60,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Use the drawing tools to create designs or drawings for classroom activities.",
      },
    },
    canvas: {
      defaultValue: {
        backgroundColor: "#ffffff",
        drawings: [],
        selectedTool: "pencil",
        lineWeight: 2,
        color: "#000000",
        disableDrag: false,
      },
      editor: FreeDrawingToolSettings,
      info: {
        label: "Actions",
        graph: {
          label: "Graph options",
          switchLabel: "Disable dragging",
        },
      },
    },
  },
  quickActions: {},
};
